import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type Store from '@ember-data/store'
import type RouterService from '@ember/routing/router-service'
import type Student from 'teacher-ui-client/models/student'

interface Params extends Record<string, unknown> {
  student_id: string
}

export default class extends Route {
  @service store!: Store

  @service router!: RouterService

  model({ student_id: studentId }: Params) {
    const student = this.store.peekRecord<Student>('student', studentId)

    if (student) {
      return { student }
    } else {
      void this.router.replaceWith('manage.students')
      return
    }
  }
}
